module.exports = __webpack_public_path__ + "img/bigfernand.d7d9d767.jpg";